// src/modules/app-views/_apps/appmulti/receivables/service.js
// *******************************************************************************
// HELPER FUNCTIONS FOR RECEIVABLES MODULE
// *******************************************************************************

// *******************************************************************************
// STATUSES (enum + filter options) — mirrors backup status enum
// *******************************************************************************
function getStatuses() {
  return [
    { label: 'new', value: 'new' },
    { label: 'in_analysis', value: 'in_analysis' },
    { label: 'waiting_for_payment', value: 'waiting_for_payment' },
    { label: 'paid', value: 'paid' },
    { label: 'received', value: 'received' },
    { label: 'overdue', value: 'overdue' },
    { label: 'cancelled', value: 'cancelled' },
    { label: 'cancelled_by_customer', value: 'cancelled_by_customer' },
  ];
}

// *******************************************************************************
// STATUS COLOR — mirrors backup getOrderStatusColor (Components.jsx)
// *******************************************************************************
function getStatusColor(status) {
  const colors = {
    new: 'purple',
    in_analysis: 'cyan',
    waiting_for_payment: 'orange',
    overdue: 'volcano',
    paid: 'green',
    received: 'lime',
    cancelled: 'default',
    cancelled_by_customer: 'default',
  };
  return colors[status] || 'geekblue';
}

// *******************************************************************************
// BILLING TYPES (no bank module — static list; Divergence #1)
// *******************************************************************************
function getBillingTypes() {
  return [
    { label: 'all_payments_title', value: 'whatever' },
    { label: 'pix', value: 'pix' },
    { label: 'slip_pix', value: 'slip_pix' },
    { label: 'credit_card', value: 'credit_card' },
  ];
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
const receivablesModuleService = {
  getStatuses,
  getStatusColor,
  getBillingTypes,
};

export default receivablesModuleService;
